import type { Media, MessageKind } from './types.ts';

/** Normalisiert Text für die Suche: Kleinbuchstaben, ohne diakritische Zeichen. */
export function normalizeSearch(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/ß/g, 'ss');
}

/** Alle Suchbegriffe müssen (als Wortanfang oder Teilwort) vorkommen. */
export function matchesQuery(haystack: string, query: string): boolean {
  const h = normalizeSearch(haystack);
  return normalizeSearch(query)
    .split(/\s+/)
    .filter(Boolean)
    .every((term) => h.includes(term));
}

/** Kurzer Ausschnitt rund um den ersten Treffer. */
export function snippet(text: string, query: string, radius = 60): string {
  const terms = normalizeSearch(query).split(/\s+/).filter(Boolean);
  const norm = normalizeSearch(text);
  const idx = terms.map((t) => norm.indexOf(t)).filter((i) => i >= 0).sort((a, b) => a - b)[0] ?? 0;
  const start = Math.max(0, idx - radius);
  const end = Math.min(text.length, idx + radius);
  return `${start > 0 ? '… ' : ''}${text.slice(start, end).trim()}${end < text.length ? ' …' : ''}`;
}

export function formatSeconds(sec: number): string {
  const s = Math.max(0, Math.round(sec));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, '0')}`;
}


/** Einzeilige Vorschau einer Nachricht für die Aufgabenliste. */
export function messagePreview(kind: MessageKind, body: string, media: Pick<Media, 'linkTitle' | 'durationSec'> | null): string {
  const text = body.trim().replace(/\s+/g, ' ');
  const dur = media?.durationSec ? ` ${formatSeconds(media.durationSec)}` : '';
  const labels: Partial<Record<MessageKind, string>> = {
    bild: 'Foto',
    video: `Video${dur}`,
    sprache: `Sprachnachricht${dur}`,
    datei: 'Datei',
    link: media?.linkTitle ?? 'Link',
    meilenstein: 'Meilenstein',
  };
  const base = text || labels[kind] || '';
  return base.length > 120 ? `${base.slice(0, 117)}…` : base;
}
